import { CSSProperties } from 'react';

import { logAnalyticsEvent } from '@vestico/utils';

export type BorderRadiusStyles = (string | undefined)[]; // top, right, bottom left

export type CustomCSSProperties = CSSProperties & { [key: string]: string | number };

export const CSSPropertiesFromString = (cssString: string | undefined) => {
  try {
    if (!cssString) {
      return {};
    }

    const items = cssString.split(';');
    const obj: CustomCSSProperties = {};
    items.forEach((item) => {
      if (item.length === 0) {
        return;
      }

      const match = /(.+?):(.+?)$/g.exec(item);
      if (!match || match.length !== 3) {
        console.error(`Cannot parse item ${item}`);
        return;
      }
      // eslint-disable-next-line prefer-destructuring
      const key = match[1];
      const value = match[2];
      const camelCased = key.startsWith('--') ? key : key.replace(/-[a-z]/g, (g) => g[1].toUpperCase());
      obj[camelCased] = value;
    });

    return obj;
  } catch (error) {
    console.error(error);
    logAnalyticsEvent({ category: 'exception', event: 'extract_css_properties', name: cssString });
    return undefined;
  }
};
